<template>
    <div style="z-index:1002" class="">
        <b-navbar toggleable="sm" type="dark" class="bgray-100 header-nav px-lg-4" >
            <!-- <b-navbar-brand>
                <div @click="pageGo" class="">
                    <b-img class="cursor header-logo" src="/images/QESG_Assessment_basic.svg"></b-img>
                </div>
            </b-navbar-brand> -->
            <b-navbar-brand v-show="!['ParticipatePreface', 'Questions'].includes($route.name)" :to="{ name: 'Main' }">
                <b-img class="cursor header-logo" src="/images/QESG_Assessment_basic.svg"></b-img>
            </b-navbar-brand>

            <b-navbar-nav v-show="['ParticipatePreface', 'Questions'].includes($route.name)">
                <b-nav-item :to="{ name: 'Main' }" link-classes="text-secondary f-95">
                    <BIconArrowLeft class="mr-1" />
                    {{ $t('진행중인 평가 목록으로 나가기') }}
                </b-nav-item>
            </b-navbar-nav>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto d-sm-flex align-items-sm-center" >
                    <!-- <b-nav-item > -->
                        <div class="d-none d-lg-block f-85 gray-600">
                            <b-badge v-if="is_premium" variant="info" class="white-text-badge">Premium User</b-badge>
                            {{ $t('hello', { company_name, user_name }) }}
                        </div>
                    <!-- </b-nav-item> -->
                    <b-nav-item>
                        <b-dropdown  id="my-info" size="sm" variant="dark-border" class="btn-round-2 ml-2 ml-sm-4" >
                            <template #button-content>
                                <fa :icon="['far','user']"></fa>
                            </template>
                            <b-dropdown-item @click.prevent="showMyInfo">
                                {{ $t('내 정보 관리') }}
                            </b-dropdown-item>
                            <!-- <b-dropdown-item :to="{name: 'PaymentList'}">
                                {{ $t('결제내역 조회') }}
                            </b-dropdown-item> -->
                        </b-dropdown>
                        <!-- <b-button v-else size="sm" variant="dark-border" class="btn-round-2 ml-2 ml-sm-4" id="my-info" @click.prevent="showMyInfo()"> <fa :icon="['far','user']"></fa> </b-button> -->
                    </b-nav-item>
                    <b-nav-item>
                        <b-button id="notice"
                            size="sm"
                            :variant="number_of_new > 0 ? 'red': 'dark-border'"
                            class="btn-round-2 ml-2"
                            @click.prevent="showNotice"
                            >
                            <fa :icon="['far','bell']"></fa>
                        </b-button>
                    </b-nav-item>
                    <b-nav-item>
                        <b-button id="faq"
                            size="sm"
                            variant="dark-border"
                            class="btn-round-2 ml-2"
                            @click.prevent="showFaq"
                            >
                            <fa icon="book"></fa>
                        </b-button>
                    </b-nav-item>
                    <b-nav-item>
                        <template v-if="is_admin >= 2"> 
                            <b-button id="go-to-user-main"
                                size="sm"
                                variant="blue-border"
                                class="btn-round-4 ml-2 ml-sm-3"
                                :to="{ name:'ProjectCodeList' }"
                                >
                                {{ $t('관리자') }}
                            </b-button>
                        </template>
                        <template v-if="is_admin === 4"> 
                            <b-button
                                :to="{ name: 'ManagingAssessment' }"
                                link-classes="h5 mb-0"
                                class="btn-round-4 ml-2 mr-1"
                                size="sm"
                                variant="blue-border"
                                >
                                📣 운영관리
                            </b-button>
                        </template>
                    </b-nav-item>
                    <b-nav-item>
                        <dropdown-language class="ml-2 ml-sm-3" size="sm" />
                    </b-nav-item>
                    <b-nav-item>
                        <b-button
                            variant="dark-border"
                            class="btn-round-4 ml-2 ml-sm-3"
                            size="sm"
                            @click="logout" 
                            > {{ $t('로그아웃') }}
                        </b-button>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-tooltip target="my-info" triggers="hover"> {{ $t('내 정보 관리') }} / {{ $t('결제내역') }}</b-tooltip>
        <b-tooltip target="notice" triggers="hover"> {{ $t('New Notice', { number_of_new } ) }}</b-tooltip>
        <b-tooltip target="faq" triggers="hover"> FAQ & {{ $t('사용 매뉴얼') }} </b-tooltip>
        <b-tooltip target="go-to-user-main" triggers="hover"> {{ $t('관리자 페이지로 이동') }} </b-tooltip>

        <b-modal id="modify-modal-top" ref="my-info" size="lg" :title="$t('내 정보 관리')" hide-footer>
            <user-info @user-save="hideMyInfoModal"></user-info>
        </b-modal>
        <b-modal id="modify-modal-top" ref="notice" size="lg" :title="$t('공지사항')" hide-footer scrollable>
            <notice @make-read-notice="makeReadNotice"></notice>
        </b-modal>
        <b-modal id="modify-modal-top" ref="faq" size="lg" :title="'FAQ & '+ $t('사용 매뉴얼')" hide-footer scrollable >
            <faq></faq>
        </b-modal>
    </div>
</template>

<script>
import { BIconArrowLeft } from 'bootstrap-vue';
import UserInfo from '@shared_components/utils/UserInfo';
import Notice from '@shared_components/utils/Notice';
import Faq from '@shared_components/utils/Faq';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import commonErrorHandling from '@shared_mixins/common-error-handling-mixin.js';

import { mapState } from 'vuex';

export default {
    name: 'customheader',
    components: {
        BIconArrowLeft,
        UserInfo,
        Notice,
        Faq,
        DropdownLanguage
    },
    mixins: [
        commonErrorHandling
    ],
    data() {
        return {
            notices: []
        };
    },
    computed: {
        ...mapState(['user_id', 'company_id', 'user_name', 'company_name', 'e_mail', 'is_admin', 'campaign_in_progress']),
        ...mapState('payment', ['is_premium']),
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        number_of_new(){
            let x = this.notices.filter((item) => {
                return item.new == true;
            });            
            return x.length;            
        },
    },
    async mounted () {
        // await this.readNotices()
        // if (this.number_of_new > 0) this.showNotice(0)
        // this.$store.commit('set_view_mode', 'provider')
    },
    methods: {
        logout(){
            this.$store.dispatch('logout').then(() => { this.$router.push({name:'Login'});  } );
        },
        showMyInfo() {
            this.$refs['my-info'].show();
        },
        showNotice() {
            this.$refs['notice'].show();
        },
        showFaq() {
            this.$refs['faq'].show();
        },
        showComments(){
            this.$refs['received-comments'].show();
        },
        pageGo(){
            this.$router.push({name:'Main'});
        },
        async readNotices () {
            try {
                const response = await this.$axios.get('/read_notices', {
                    params: { company_id: this.company_id, user_id: this.user_id }
                });
                this.notices = response.data.notices;
            } catch (error) {
                await this.common_error_handling(error);
            }
        },
        hideMyInfoModal(){
            this.$refs['my-info'].hide();
        },
        makeReadNotice (notice_id) {
            let idx = this.notices.findIndex(item => item.notice_id == notice_id);
            if(idx > -1){
                let new_notice = { ...this.notices[idx] };
                new_notice.new = false;
                this.notices.splice(idx, 1, new_notice);
            }
        }
    }
};
</script>

<style>
.header-nav > div.navbar-brand, .header-nav > div>ul>li>a.nav-link {
    padding:0!important;
}
.header-nav >.navbar-toggler {
    border-color: transparent;
}

.header-nav >.navbar-toggler >.navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(100,100,100,0.7)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")
}

@media (max-width: 574px) {
    .header-nav > div> ul.navbar-nav  {
        margin-top: 0.75rem;
        display: inline-block!important;
    }
    .header-nav > div> ul>li  {
        float:left!important;
    }

}
#my-info > ul {
    z-index: 1030;
}
.white-text-badge {
  color: white !important;
}
</style>
